import(/* webpackMode: "eager" */ "/home/ubuntu/IdxAutoBotNext/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"],\"display\":\"optional\",\"preload\":false}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/IdxAutoBotNext/src/app/analytics.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/IdxAutoBotNext/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/IdxAutoBotNext/src/app/trial-badge.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/IdxAutoBotNext/src/components/ErrorBoundary.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/IdxAutoBotNext/src/components/layout/AppChrome.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/IdxAutoBotNext/src/components/system-errors/SystemErrorGlobalReporter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReduxProvider"] */ "/home/ubuntu/IdxAutoBotNext/src/redux/Provider.jsx");
